import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface LearningMaterialMarkdownProps {
  contentMarkdown: string;
}

function getAllowedLinkProtocol(href: string): string | undefined {
  if ((href.startsWith('/') && !href.startsWith('//')) || href.startsWith('#')) {
    return 'relative';
  }

  try {
    return new URL(href).protocol;
  } catch {
    return undefined;
  }
}

function isAllowedLinkTarget(href: string | undefined): boolean {
  if (!href) {
    return false;
  }

  const protocol = getAllowedLinkProtocol(href);
  return protocol !== undefined && ['relative', 'http:', 'https:', 'mailto:'].includes(protocol);
}

export function LearningMaterialMarkdown({ contentMarkdown }: LearningMaterialMarkdownProps) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children }) => {
          if (!isAllowedLinkTarget(href)) {
            return <>{children}</>;
          }
          const protocol = getAllowedLinkProtocol(href!);
          const isExternal = protocol === 'http:' || protocol === 'https:';
          return (
            <a href={href} {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
              {children}
            </a>
          );
        },
        img: () => null,
        table: ({ children }) => (
          <div className="learning-material-reader__table-scroll">
            <table>{children}</table>
          </div>
        ),
      }}
    >
      {contentMarkdown}
    </ReactMarkdown>
  );
}
